export function iconMapFn(iconName) {
    switch (iconName) {
        // Translate icons used in quasar components to our icons
        case 'arrow_drop_down': iconName = 'caret-down'; break;
        case 'arrow_upward': iconName = 'sort'; break;
        case 'chevron_left': iconName = 'left'; break;
        case 'chevron_right': iconName = 'right'; break;
    }

    return {
        cls: `mf-icons mf-${iconName}`,
    };
}
